import React from 'react';
import { StyledAutomaticField } from './StyledStats';

import { AutomaticFieldProps } from './StatsTypes';
import { MatchStatisticStatus } from '../../enums/matchStatisticStatus';
import { selectMatchStatisticsAdmin } from '../../features/match/matchSlice';
import { useSelector } from 'react-redux';
import LoadingSpinner from '../../atoms/LoadingSpinner';

const AutomaticField: React.FC<AutomaticFieldProps> = ({ label, data, statsSelect }) => {
  const { home, away } = data;
  const { homeId, awayId } = statsSelect.ids;
  const matchStatistics = useSelector(selectMatchStatisticsAdmin);
  const matchStatisticHome = matchStatistics?.find((matchStatistic) => matchStatistic.id === homeId);
  const matchStatisticAway = matchStatistics?.find((matchStatistic) => matchStatistic.id === awayId);
  const loadingHome =
    matchStatisticHome &&
    [MatchStatisticStatus.POSTING, MatchStatisticStatus.PATCHING].includes(matchStatisticHome.status);
  const loadingAway =
    matchStatisticAway &&
    [MatchStatisticStatus.POSTING, MatchStatisticStatus.PATCHING].includes(matchStatisticAway.status);

  return (
    <StyledAutomaticField>
      {loadingHome && <LoadingSpinner loading={true} />}
      {!loadingHome && <div className="statsCircle">{home}</div>}
      <div className="label">{label}</div>
      {loadingAway && <LoadingSpinner loading={true} />}
      {!loadingAway && <div className="statsCircle">{away}</div>}
    </StyledAutomaticField>
  );
};

export default AutomaticField;
